"use strict";

require("./terms-of-service.modal.js");

angular.module("core").component("termsOfService", {
    templateUrl: require("./terms-of-service.component.html"),
    bindings: {
        model: "=",
        formName: "<",
        readonly: "@",
        submitFlag: "<"
    },
    controller: function($scope, $rootScope, $resource, Language, ModalService) {
        var controller = this;
        var unregister = Language.initializeController(this, "language", null);
        var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
            controller.language = new_language;
        });

        this.$onDestroy = function() {
            unregisterLanguageChanged();
            unregister();
        };

        $scope.openTermsOfService = function() {
            ModalService.showModal({
                templateUrl: require("./terms-of-service.modal.html"),
                controller: "TermsOfServiceModalController",
                controllerAs: "selector"
            }).then(function(modal) {
                modal.element.modal();
                modal.element.on("hidden.bs.modal", function(e) {
                    modal.element.remove();
                });
                modal.close.then(function(result) {
                    modal.element.remove();
                });
            });
        }

    },
});



//////////////////
// WEBPACK FOOTER
// ./core/terms-of-service/terms-of-service-agreement/terms-of-service.component.js
// module id = 553
// module chunks = 0